<template>
  <el-tooltip effect="dark" :content="$t('main_menu_download_center')" placement="bottom">
    <el-button class="public-icon" type="text" size="medium" @click="toDownCenter">
      <i class="icon-down-center public-icon-i"></i>
    </el-button>
  </el-tooltip>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'DownCenter',
  components: {},
  setup() {
    const router = useRouter()

    /**
     * 下载中心路由地址
     */
    const path = '/portal/center/async-export'

    const toDownCenter = () => {
      router.push(path)
    }

    return {
      toDownCenter
    }
  }
})
</script>

<style lang="scss" scoped>
.icon-down-center {
  background-image: url('~@/assets/down-center.svg');
  background-size: 110% 110%;
  display: block;
  width: 18px;
  height: 18px;
}
</style>
